import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {ThreadStatus} from 'nutshell-graphql-types';
import type {CreateShelly as CreateShellyMutation} from 'nutshell-graphql-types';

import {useGetLatestThreads, useGetInboxThreadCounts} from '../../../graphql/hooks';

import CREATE_SHELLY from '../mutations/create-shelly.graphql';

export const useCreateShelly = (
    status: ThreadStatus,
    assignees: string[]
): {
    createShelly: () => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const {refetch: refetchInboxThreadCounts} = useGetInboxThreadCounts({assignees});
    const {refetch: refetchLatestThreads} = useGetLatestThreads({
        status,
        assignees,
        threadType: 'SMS',
    });

    const [createShelly, {loading, error}] = useMutation<CreateShellyMutation, Record<any, any>>(
        CREATE_SHELLY
    );

    return {
        createShelly: () =>
            createShelly().then(() => {
                refetchInboxThreadCounts();
                refetchLatestThreads();
            }),
        isLoading: loading,
        // @ts-expect-error
        error: error && safelyGetGraphQLErrorMessage(error),
    };
};
